
































































































































import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { DialogForm, FormOverlay } from '@/components/bwaff';

import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import UserApi from '@/services/rest/bemob/user';

@Component({
  components: {
    FormOverlay,
    DialogForm,
    ErrorAggregator,
  },
})
export default class ResendPostbacks extends Vue{
  @Prop({ default: {res:{},details:[]} })
  data: any;

  resendValidLoading = false;
  resendFirstTimeLoading = false;
  resendAllLoading = false;
  resendComplete = false;

  dataToShow: {
    requested: number,
    sent: number,
    failed: number,
    res:{},
    details:[]
  } = {
    requested: 0,
    sent: 0,
    failed: 0,
    res:{},
    details:[]
  };

  isBeforeSend: boolean = true;

  userApi: UserApi = new UserApi();

  circleColor(status) {
    switch (status) {
      case 'sent':
        return this.$colors.green;
      case 'skipped':
        return this.$colors.tangerine;
      case 'ready':
        return this.$colors.gray20;
      case 'failed':
        return this.$colors.red;
    }
  }

  statusText(statusCode) {
    if(statusCode >= 200 && statusCode < 400){
      return this.t('The conversion data was successfully forwarded to the traffic source.');
    }
    if(statusCode >= 400 && statusCode < 500){
      return this.t('The conversion data was rejected by the traffic source.');
    }
    if(statusCode >= 500){
      return this.t('An error occurred on the traffic source side.');
    }
  }

  mounted() {
    this.dataToShow = this.data;
    this.isBeforeSend = this.data.isBeforeSend;
  }

  get selectedItemsIds(){
    return this.$store.state.table.selectedItems.map((item: any) => item.DT_RowId);
  }

  get modalTitle(){
    if(this.isBeforeSend){
       return this.t('Resend Postbacks') + ': ' + this.t('Review Records');
    }
    return this.t('Resend Postbacks') + ': ' + this.t('Results');
  }

  get tableItems(){
    if(this.isBeforeSend){
      return this.$store.state.table.selectedItems.map(item=>{
        return {
          postbackUrl: item['postbacks-url'],
          timestamp: item['postbacks-timestamp'],
          id: item['postbacks-clickid'],
        }
      })
    }
    return this.dataToShow.details
  }

  get headers() {
    return [
      {
        text: this.t('Id'),
        value: 'id',
        sortable: false,
        help: this.t('Unique Click ID generated by BeMob.')
      },
      {
        text: this.t('Timestamp'),
        value: 'timestamp',
        sortable: false,
        help: this.t('Date and time of the first attempt to send the conversion to the traffic source.')
      },
      {
        text: this.t('Postback URL'),
        value: 'postbackUrl',
        sortable: false,
        help: this.t('Postback URL used to send the conversion.')
      },
      {
        text: this.t('Details'),
        value: 'details',
        sortable: false,
        help: this.t('Status of the resent conversion with color indicator.')
      }
    ];
  }

  close() {
    if(!this.isBeforeSend){
      this.bus.emit('reload-report');
    }
    this.$emit('close');
  }

  resendValid() {
    this.$store.commit('loading', true);
    this.resendValidLoading = true;
    this.userApi.postSendPostbacks({ ids:this.selectedItemsIds, mode: 'valid' }).then((res)=>{
      this.dataToShow=res;
      // this.bus.emit('reload-report');
      // this.close();
      this.resendComplete = true;
    }).finally(()=>{
      this.$store.commit('loading', false);
      this.resendValidLoading = false;
    });
  }

  resendFirstTime() {
    this.$store.commit('loading', true);
    this.resendFirstTimeLoading = true;
    this.userApi.postSendPostbacks({ ids:this.selectedItemsIds, mode: 'default' }).then((res)=>{
      this.dataToShow=res;
      this.isBeforeSend = false;
      // this.bus.emit('reload-report');
      // this.close();

      const {requested, sent, failed} = res;
      if(requested===sent){
        this.bus.emit('toast-success', this.t('Conversions sent successfully. You can close this window and continue.'));
      }
      if(requested!==sent && requested!==failed){
        this.bus.emit('toast-warning', this.t('The request was resent, but an error occurred during sending.<br> Check Details for the error reason. <br>Do not resend until the issue is fixed.'));
      }
      if(requested===failed){
        this.bus.emit('toast-error', this.t('Some conversions were sent successfully, but errors occurred for others during sending. <br>Check Details for the error reason.<br>Do not resend until the issue is fixed.'));
      }
    }).finally(()=>{
      this.$store.commit('loading', false);
      this.resendFirstTimeLoading = false;
    });
  }


  resendAll() {
    this.$store.commit('loading', true);
    this.resendAllLoading = true;
    this.userApi.postSendPostbacks({ ids:this.selectedItemsIds, mode: 'all' }).then((res)=>{
      this.dataToShow=res;
      // this.close();
      this.resendComplete = true;

      const {requested, sent, failed} = res;
      if(requested===sent){
        this.bus.emit('toast-success', this.t('Conversions sent successfully. You can close this window and continue.'));
      }
      if(requested!==sent && requested!==failed){
        this.bus.emit('toast-warning', this.t('The request was resent, but an error occurred during sending.<br> Check Details for the error reason. <br>Do not resend until the issue is fixed.'));
      }
      if(requested===failed){
        this.bus.emit('toast-error', this.t('Some conversions were sent successfully, but errors occurred for others during sending. <br>Check Details for the error reason.<br>Do not resend until the issue is fixed.'));
      }
    }).finally(()=>{
      this.resendAllLoading = false;
      this.$store.commit('loading', false);
    });
  }
}
